import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { OnlineSchedulingParams } from 'interfaces/onlineSchedulingParams';

interface RoiPatientAgeParams extends OnlineSchedulingParams {
  ageRanges: string[];
}

export interface AgeDistributionDetail {
  fromAge: number;
  toAge: number;
  totalPatients: number;
}

export interface RoiPatientAgeData {
  periodData: {
    ageDistribution: AgeDistributionDetail[];
    period: {
      startDate: string;
      endDate: string;
    };
  };
}

const useRoiPatientAge = (params: RoiPatientAgeParams) => {
  const storedId = loadSelectedClinicId();
  const clinicIds = params.clinicIds ?? [storedId];
  const query =
    params.startDate && params.endDate
      ? new URLSearchParams({
          startDate: params.startDate,
          endDate: params.endDate,
          hourType: params.hourType,
        }).toString()
      : '';

  const url =
    params.startDate && params.endDate
      ? `/rois/patients/age-distribution?${query}`
      : null;

  const { data, error, isValidating, mutate } = useSWR(
    url ? [url, clinicIds] : null,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<RoiPatientAgeData>(url, {
        params: { clinicIds, ageRanges: params.ageRanges },
      });
      return response.data;
    }
  );

  if (!params.startDate || !params.endDate) {
    return {
      data: null,
      error: undefined,
      isLoading: false,
      isValidating: false,
      mutate: async () => {},
    };
  }

  return {
    data,
    error,
    isLoading: !data && !error,
    isValidating,
    mutate,
  };
};

export default useRoiPatientAge;
